import { useEffect, useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import SetPasswordModal, { passwordSnoozed } from './SetPasswordModal'

export default function PasswordSetupGate() {
  const auth: any = useAuth()
  const [dismissed, setDismissed] = useState(passwordSnoozed())
  // A fresh magic-link click (new session) re-offers the modal.
  useEffect(() => { setDismissed(passwordSnoozed()) }, [auth?.user?.id])
  const profile = auth?.userProfile
  if (auth?.isLoading || !auth?.user || !profile) return null
  if ((profile as any).password_set_at != null) return null
  if (dismissed) return null
  return <SetPasswordModal onDone={() => setDismissed(true)} />
}